import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const StyledSection = styled(Box)`
  padding: ${themeSpace(9)} ${themeSpace(4)} 0;
  ${themeMediaQuery('below_sm')} {
    padding: ${themeSpace(2)} ${themeSpace(4)} 0;
  }
`;

export const StyledFlex = styled(Flex)`
  width: 100%;
  max-width: 390px;
  ${themeMediaQuery('sm')} {
    max-width: 520px;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-body {
    max-width: 913px;
    font-size: 24px;
    line-height: 36px;
    ${themeMediaQuery('below_sm')} {
      max-width: 272px;
      font-size: 17px;
      line-height: 27px;
    }
  }
  .text-pairing-title {
    width: 500px;
    ${themeMediaQuery('below_sm')} {
      max-width: 311px;
      font-size: 40px;
      line-height: normal;
    }
    ${themeMediaQuery('xl')} {
      width: 700px;
    }
  }
`;
